<template>
  <v-container fluid>
    <v-dialog/>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Résultat des dispatchings
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#FFEB3B" dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">Liste de {{ errors.length }} message(s) pour le dispatching du {{ idFctIssuer }}.
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Message n° " + ++index + " ->" + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <modal :adaptive=true
               :clickToClose="false"
               :draggable=false
               :resizable=false
               height="auto"
               name="modal-fade-reports">
          <v-card>
            <v-toolbar
                color="primary"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            label="Date du reporting"
                            readonly
                            rounded>
              </v-text-field>
              <v-btn @click="hideR"
                     dark
                     fab
                     small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-row class="justify-center align-center">
                  <v-col cols="12" md="9" sm="12">
                    <v-menu
                        :close-on-content-click="false"
                        min-width="290px"
                        offset-y
                        transition="scale-transition"
                        v-model="menuR"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :id="dynamicID()"
                                      class="centered-input align-center"
                                      label="Date dispatching"
                                      persistent-hint
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-model="computedDateFormattedR"
                                      v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          @input="menuR= false"
                          locale="fr-FR"
                          v-model="dateReports"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="AnnulerR"
                         class="white--text"
                         color="#01579B" depressed>Annuler
                  </v-btn>
                  <v-btn :disabled="!FormIsValidR && !loading" @click="ValiderR"
                         class="white--text"
                         color="#01579B" depressed>Valider
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-container>
          </v-card>
        </modal>
        <modal :adaptive=true
               :clickToClose="false"
               :draggable=false
               :resizable=false
               height="auto"
               name="modal-fade-observations">
          <v-card>
            <v-toolbar
                color="primary"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            label="Fenêtre de saisie"
                            readonly
                            rounded>
              </v-text-field>
              <v-btn @click="hide()"
                     dark
                     fab
                     small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-row class="justify-center align-center">
                  <v-col cols="12" md="9" sm="12">
                    <v-select :items="nameCategAgent"
                              @change="loadCategoriesAgent"
                              class="centered-input align-center text-center"
                              item-text="type" item-value="type"
                              label="Catégorie"
                              prepend-inner-icon="mdi-list-status"
                              v-model="editedItem.categAgent">
                      <template v-slot:selection="{ item }">
                                                  <span class="d-flex justify-center" style="width: 100%;">
                                                    {{ item }}
                                                  </span>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row class="justify-center align-center">
                  <v-col cols="12" md="9" sm="12">
                    <v-text-field :id="dynamicID()"
                                  class="centered-input align-center"
                                  color="#01579B" label="0bservations"
                                  prepend-inner-icon="mdi-comment-edit-outline"
                                  rows="1"
                                  textarea
                                  v-model="observations"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="Annuler"
                         class="white--text"
                         color="#01579B" depressed>Annuler
                  </v-btn>
                  <v-btn :disabled="!FormIsValidCst && !loading" @click="Valider"
                         class="white--text"
                         color="#01579B" depressed>Valider
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-container>
          </v-card>
        </modal>
        <v-card class="mt-1" flat tile>
          <v-row>
            <v-col>
              <v-select :disabled="disableMainBtn" :items="selectDates" @change="depthDate" dense
                        filled
                        full-width
                        hide-details="true"
                        item-text="name"
                        item-value="value" return-object solo style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="generateRapport" block
                     class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-pdf-outline</v-icon>
                <span>Export Rapport</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="generatePDF" block class="custom-btn white--text"
                     color="#03A9F4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-pdf-outline</v-icon>
                <span>Export PDF</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export Excel</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="init()" block
                         class="custom-btn white--text"
                         color="#009688" height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Dispatching</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1">Dispatching</v-tab>
                    <v-tab href="#tab-2">Affectation</v-tab>
                    <v-tab href="#tab-3">Suppression</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="12">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menu"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Date du dispatching"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDispatchingDate"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="menu= false"
                                    locale="fr-FR"
                                    v-model="editedItem.dispatchingDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="12">
                              <v-select :items="shifts"
                                        class="centered-input align-center text-center"
                                        item-text="type"
                                        item-value="type" label="Nom du shift"
                                        prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                                        v-model="editedItem.shiftName">
                                <template v-slot:selection="{ item }">
                                                                  <span class="d-flex justify-center"
                                                                        style="width: 100%;">
                                                                    {{ item }}
                                                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Exécution
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="12">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menu1"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Date du dispatching"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDispatchingDate1"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="menu1= false"
                                    locale="fr-FR"
                                    v-model="editedItem.dispatchingDate1"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="12">
                              <v-select :items="shifts"
                                        class="centered-input align-center text-center"
                                        item-text="type"
                                        item-value="type" label="Nom du shift"
                                        prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                                        v-model="editedItem.shiftName1">
                                <template v-slot:selection="{ item }">
                                                                  <span class="d-flex justify-center"
                                                                        style="width: 100%;">
                                                                    {{ item }}
                                                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col md="9" sm="6">
                              <v-select :items="namePosts"
                                        @change="loadPostes"
                                        class="centered-input align-center text-center"
                                        item-text="type" item-value="type"
                                        label="Nom du poste"
                                        prepend-inner-icon="mdi-select-place"
                                        v-model="editedItem.postName1">
                                <template v-slot:selection="{ item }">
                                                                  <span class="d-flex justify-center"
                                                                        style="width: 100%;">
                                                                    {{ item }}
                                                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            disabled
                                            label="Nom de la zone"
                                            prepend-inner-icon="mdi-image-area"
                                            v-model="editedItem.zoneName1">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B"
                                            label="Matricule"
                                            prepend-inner-icon="mdi-human-male"
                                            v-model="editedItem.userId1">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B" label="Observations"
                                            prepend-inner-icon="mdi-comment-edit-outline"
                                            rows="1"
                                            textarea
                                            v-model="observations"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="affectation"
                               class="white--text"
                               color="#01579B" depressed>Exécution
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item style="background-color: #FFEBEE" value="tab-3">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="12">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menuS"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Date du dispatching"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDispatchingDateS"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="menuS= false"
                                    locale="fr-FR"
                                    v-model="editedItem.dispatchingDateS"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="9" sm="12">
                              <v-select :items="shifts"
                                        class="centered-input align-center text-center"
                                        item-text="type"
                                        item-value="type" label="Nom du shift"
                                        prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                                        v-model="editedItem.shiftNameS">
                                <template v-slot:selection="{ item }">
                                                                  <span class="d-flex justify-center"
                                                                        style="width: 100%;">
                                                                    {{ item }}
                                                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="supprimer"
                               class="white--text"
                               color="#F44336" depressed>Suppression
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <template>
            <modal :adaptive=true
                   :clickToClose=true
                   :draggable=false
                   :resizable=false
                   height="auto"
                   name="modal-fade"
                   width="80%">
              <template>
                <vue-pdf-app
                    :file-name="fileNameSrc"
                    :pdf="pdfsrc"
                    :title="true"
                    style="height: 100vh;">
                </vue-pdf-app>
              </template>
            </modal>
          </template>
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import {depthDate} from "../../../helper/profondeur";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import imageToBase64 from 'image-to-base64/browser'
import MotionPicture from "../../../assets/Fonts/MotionPicture-normal.js"
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 5) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Postes4rules"));
  } else if (col === 6) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("CategoriesAgent"));
  }
}

function cellRendererZ1(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (column === 8 || column === 9)
    td.className = "colZ1Name htCenter htMiddle";
  else if (column === 4)
    td.className = "colZ1 htCenter htMiddle";

  if (column === 3) {
    if (value === "TSA-BRG-1") {
      td.className = "colTSABRG1 htCenter htMiddle";
    } else if (value === "TSA-BRG-2") {
      td.className = "colTSABRG2 htCenter htMiddle";
    } else if (value === "TSA-BRG-3") {
      td.className = "colTSABRG3 htCenter htMiddle";
    } else if (value === "TSA-BRG-4") {
      td.className = "colTSABRG4 htCenter htMiddle";
    } else td.className = "colTSABRGX htCenter htMiddle";
  }
}

function cellRendererZ2(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (column === 8 || column === 9)
    td.className = "colZ2Name htCenter htMiddle";
  else if (column === 4)
    td.className = "colZ2 htCenter htMiddle";

  if (column === 3) {
    if (value === "TSA-BRG-1") {
      td.className = "colTSABRG1 htCenter htMiddle";
    } else if (value === "TSA-BRG-2") {
      td.className = "colTSABRG2 htCenter htMiddle";
    } else if (value === "TSA-BRG-3") {
      td.className = "colTSABRG3 htCenter htMiddle";
    } else if (value === "TSA-BRG-4") {
      td.className = "colTSABRG4 htCenter htMiddle";
    } else td.className = "colTSABRGX htCenter htMiddle";
  }
}

function cellRendererZ3(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (column === 8 || column === 9)
    td.className = "colZ3Name htCenter htMiddle";
  else if (column === 4)
    td.className = "colZ3 htCenter htMiddle";

  if (column === 3) {
    if (value === "TSA-BRG-1") {
      td.className = "colTSABRG1 htCenter htMiddle";
    } else if (value === "TSA-BRG-2") {
      td.className = "colTSABRG2 htCenter htMiddle";
    } else if (value === "TSA-BRG-3") {
      td.className = "colTSABRG3 htCenter htMiddle";
    } else if (value === "TSA-BRG-4") {
      td.className = "colTSABRG4 htCenter htMiddle";
    } else td.className = "colTSABRGX htCenter htMiddle";
  }
}

function cellRendererZ4(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (column === 8 || column === 9)
    td.className = "colZ4Name htCenter htMiddle";
  else if (column === 4)
    td.className = "colZ4 htCenter htMiddle";

  if (column === 3) {
    if (value === "TSA-BRG-1") {
      td.className = "colTSABRG1 htCenter htMiddle";
    } else if (value === "TSA-BRG-2") {
      td.className = "colTSABRG2 htCenter htMiddle";
    } else if (value === "TSA-BRG-3") {
      td.className = "colTSABRG3 htCenter htMiddle";
    } else if (value === "TSA-BRG-4") {
      td.className = "colTSABRG4 htCenter htMiddle";
    } else td.className = "colTSABRGX htCenter htMiddle";
  }
}

function cellRendererZ5(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (column === 8 || column === 9)
    td.className = "colZ5Name htCenter htMiddle";
  else if (column === 4)
    td.className = "colZ5 htCenter htMiddle";

  if (column === 3) {
    if (value === "TSA-BRG-1") {
      td.className = "colTSABRG1 htCenter htMiddle";
    } else if (value === "TSA-BRG-2") {
      td.className = "colTSABRG2 htCenter htMiddle";
    } else if (value === "TSA-BRG-3") {
      td.className = "colTSABRG3 htCenter htMiddle";
    } else if (value === "TSA-BRG-4") {
      td.className = "colTSABRG4 htCenter htMiddle";
    } else td.className = "colTSABRGX htCenter htMiddle";
  }
}

function cellRendererZ6(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (column === 8 || column === 9)
    td.className = "colZ6Name htCenter htMiddle";
  else if (column === 4)
    td.className = "colZ6 htCenter htMiddle";

  if (column === 3) {
    if (value === "TSA-BRG-1") {
      td.className = "colTSABRG1 htCenter htMiddle";
    } else if (value === "TSA-BRG-2") {
      td.className = "colTSABRG2 htCenter htMiddle";
    } else if (value === "TSA-BRG-3") {
      td.className = "colTSABRG3 htCenter htMiddle";
    } else if (value === "TSA-BRG-4") {
      td.className = "colTSABRG4 htCenter htMiddle";
    } else td.className = "colTSABRGX htCenter htMiddle";
  }
}

function cellRendererZX(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if (column === 8 || column === 9)
    td.className = "colZXName htCenter htMiddle";
  else if (column === 4)
    td.className = "colZX htCenter htMiddle";

  if (column === 3) {
    if (value === "TSA-BRG-1") {
      td.className = "colTSABRG1 htCenter htMiddle";
    } else if (value === "TSA-BRG-2") {
      td.className = "colTSABRG2 htCenter htMiddle";
    } else if (value === "TSA-BRG-3") {
      td.className = "colTSABRG3 htCenter htMiddle";
    } else if (value === "TSA-BRG-4") {
      td.className = "colTSABRG4 htCenter htMiddle";
    } else td.className = "colTSABRGX htCenter htMiddle";
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "account_details",
  components: {HotTable, VuePdfApp},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      fileNameSrc: null,
      pdfsrc: null,
      bShowPDF: true,
      reportsMessage: null,
      menuR: null,
      dateReports: null,
      indEnr: 0,
      namePDFile: "Détails des dispatchings TSA",
      imgFooter: require('../../../assets/Logo_TSA_fine.png'),
      heading: "Dispatching ",
      tabDispatchAllMessages: [],
      disableMainBtn: false,
      idFctIssuer: "",
      commande: "",
      searchName: "",
      observations: "",
      listPresencesNotPlanned: [],
      shifts: [],
      shiftsFull: [],
      namePostsZones: [],
      namePosts: [],
      nameZones: [],
      nameCtgContraintesAgt: [],
      nameCategAgent: [],
      nameContrainteAgent: [],
      dialogTmp: false,
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      menu: null,
      menu1: null,
      menuS: null,
      type: null,
      elapse: null,
      loading: false,
      menustartWorkingDate: false,
      toObject: [],
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      editedItem: {
        id: "",
        postName: "",
        zoneName: "",
        zoneName1: "",
        shiftName: "",
        shiftNameS: "",
        categAgent: "",
        contrainteAgent: "",
        dispatchingDate: (moment().format("YYYY-MM-DD")).toString(),
        brigade: "",
        userId: "",
        postName1: "",
        shiftName1: "",
        dispatchingDate1: (moment().format("YYYY-MM-DD")).toString(),
        dispatchingDateS: (moment().format("YYYY-MM-DD")).toString(),
        userId1: "",
        accountFirstname: "",
        accountLastname: "",
        sexe: "",
        contrainte: ""
      },
      show1: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterOnCellMouseUp: this.afterOnCellMouseUpMe,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Date dispatching", "Nom shift", "Brigade", "Nom zone", "Nom poste", "Catégorie", "Matricule", "Nom", "Prénom(s)", "Statut", "Date création"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {
            title: "Date dispatching",
            width: "180px",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Nom shift", width: "200px", readOnly: true},
          {title: "Brigade", width: "200px", readOnly: true},
          {title: "Nom zone", width: "160px", readOnly: true},
          {
            title: "Nom poste",
            width: "350px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Catégorie",
            width: "230px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {title: "Matricule", width: "150px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom(s)", width: "200px", readOnly: true},
          {title: "Statut", width: "200px", readOnly: true},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          }
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 3 || col === 4 || col === 8 || col === 9) {
            const cellValueZone = this.instance.getSourceDataAtCell(row, 4);

            if (cellValueZone === "ZONE 1") {
              cellProperties.renderer = cellRendererZ1;
            } else if (cellValueZone === "ZONE 2") {
              cellProperties.renderer = cellRendererZ2;
            } else if (cellValueZone === "ZONE 3") {
              cellProperties.renderer = cellRendererZ3;
            } else if (cellValueZone === "ZONE 4") {
              cellProperties.renderer = cellRendererZ4;
            } else if (cellValueZone === "ZONE 5") {
              cellProperties.renderer = cellRendererZ5;
            } else if (cellValueZone === "ZONE 6") {
              cellProperties.renderer = cellRendererZ6;
            } else if (cellValueZone === "ZONE X") {
              cellProperties.renderer = cellRendererZX;
            }
          }

          return cellProperties;
        }
      }
    }
  },
  created() {
    this.loadPostes()
    this.loadShifts()
    this.initEditedItem()
    this.loadCategoriesAgent()
    this.getData()
  },

  computed: {
    FormIsValid() {
      if (this.tab === "tab-1") {
        return (
            this.editedItem.shiftName !== "" &&
            this.editedItem.dispatchingDate !== ""
        );
      } else if (this.tab === "tab-2") {
        return (
            this.editedItem.postName1 !== "" &&
            this.editedItem.userId1 !== "" &&
            this.editedItem.shiftName1 !== "" &&
            this.editedItem.dispatchingDate1 !== "" &&
            this.observations !== ""
        );
      } else if (this.tab === "tab-3") {
        return (
            this.editedItem.shiftNameS !== "" &&
            this.editedItem.dispatchingDateS !== ""
        );
      }

      return true;
    },
    FormIsValidR() {
      return (this.dateReports !== null);
    },
    FormIsValidCst() {
      return (this.observations !== "" &&
          this.editedItem.categAgent !== "");
    },
    userRole() {
      return this.$store.getters.user.role;
    },
    computedDispatchingDate() {
      return this.formatDate(this.editedItem.dispatchingDate)
    },
    computedDispatchingDate1() {
      return this.formatDate(this.editedItem.dispatchingDate1)
    },
    computedDispatchingDateS() {
      return this.formatDate(this.editedItem.dispatchingDateS)
    },
    computedDateFormattedR() {
      return this.formatDate(this.dateReports)
    },
  },

  methods: {
    getNbrAgentsByBRG(tab, date, shift, brg) {
      let nbr = 0
      for (var i = 0; i < tab.length; i++) {
        if ((tab[i][1] === date) && (tab[i][2] === shift) && (tab[i][3] === brg)) {
          ++nbr;
        }
      }

      return nbr;
    },
    getNbrAgentsByZone(tab, date, shift, brg, zone) {
      let nbr = 0
      for (var i = 0; i < tab.length; i++) {
        if ((tab[i][1] === date) && (tab[i][2] === shift) && (tab[i][3] === brg) && (tab[i][4] === zone)) {
          ++nbr;
        }
      }

      return nbr;
    },
    getNbrAgentsByDispatchDateShift(tab, date, shift) {
      let nbr = 0
      for (var i = 0; i < tab.length; i++) {
        if ((tab[i][1] === date) && (tab[i][2] === shift)) {
          ++nbr;
        }
      }

      return nbr;
    },
    generateRapport() {
      this.dateReports = null;
      this.showR()
    },
    generateRapportPDF() {
      let imgBase64 = ""

      imageToBase64(require('../../../assets/Logo_TSA_fine.png')) // Image URL
          .then(
              (response) => {
                imgBase64 = response
                if (this.reportsMessage.length <= 1) {
                  this.text = "Le dispatching à afficher est vide. Contactez le support CartaLink.";
                  this.showAlert('warning')
                  return;
                }

                let doc = new jsPDF({
                  orientation: "portrait",
                  unit: "mm",
                  format: "letter"
                });

                let strDateReports = moment(this.dateReports, "YYYY-MM-DD").format("DD-MM-YYYY").toString();

                doc.autoTable({
                  head: this.headRowsBRGR(doc, response, strDateReports),
                  headStyles: {
                    fillColor: [241, 196, 15],
                    fontSize: 15,
                    valign: 'middle'
                  },
                  body: this.bodyRowsR(doc),
                  footStyles: {
                    fillColor: [241, 196, 15],
                    fontSize: 12,
                    halign: 'right',
                    valign: 'middle'
                  },
                });

                // PAGE NUMBERING
                // Add Page number at bottom-right
                // Get the number of pages
                const pageCount = doc.internal.getNumberOfPages();

                // For each page, print the page number and the total pages
                for (var i = 1; i <= pageCount; i++) {
                  // Go to page i
                  doc.setPage(i);
                  //Print Page 1 of 4 for example  // Creating footer and saving file
                  this.footPageR(doc)
                  doc
                      .setTextColor(25, 52, 101)
                      .text("Page " + String(i) + " sur " + String(pageCount), 200, doc.internal.pageSize.height - 15, {align: "right"});
                }

                //doc.save("Global reporting - " + moment(this.dateReports, "YYYY-MM-DD").format("DD-MM-YYYY").toString() + ".pdf");
                this.pdfsrc = doc.output("arraybuffer");
                this.fileNameSrc = "Global reporting - " + moment(this.dateReports, "YYYY-MM-DD").format("DD-MM-YYYY").toString() + ".pdf"
                this.showPDF()
              }
          )
          .catch(
              (error) => {
                console.log(error); // Logs an error if there was one
              }
          )
    },
    generatePDF() {
      let imgBase64 = ""

      imageToBase64(require('../../../assets/Logo_TSA_fine.png')) // Image URL
          .then(
              (response) => {
                imgBase64 = response

                if (this.toObject.length <= 1) {
                  this.text = "Il n'y a aucun enregistrement à télécharger.";
                  this.showAlert('warning')
                  return;
                }

                let doc = new jsPDF({
                  orientation: "portrait",
                  unit: "in",
                  format: "letter"
                });

                let brgNameCurrent = ""
                let zoneNameCurrent = ""
                let nameDispatchShift = ""
                let currentShift = ""
                let currentDate = ""
                let nextShift = ""
                let nextDate = ""

                let refCurrent = ""
                let refOld = ""
                let indi = 0
                let indj = 0

                let nbrAgentsByBRG = 0
                let nbrAgentsByZone = 0
                let nbrAgentsByDispatchDateShift = 0

                let toObjectTmp = []
                Array.prototype.push.apply(toObjectTmp, this.toObject);
                toObjectTmp.shift()

                for (indi = 0; indi < toObjectTmp.length; indi++) {
                  let finalTab = []

                  currentDate = toObjectTmp[indi][1]
                  currentShift = toObjectTmp[indi][2]

                  nameDispatchShift = currentDate + " / " + currentShift
                  brgNameCurrent = toObjectTmp[indi][3]
                  zoneNameCurrent = toObjectTmp[indi][4]

                  for (indj = indi; indj < toObjectTmp.length; indj++) {
                    refOld = refCurrent;
                    refCurrent = toObjectTmp[indj][3] + " " + toObjectTmp[indj][4]

                    if (refOld === "") { // Le 1er
                      finalTab.push(toObjectTmp[indj]);
                    } else {
                      if (refOld !== refCurrent) {
                        break;
                      }
                      finalTab.push(toObjectTmp[indj]);
                    }
                  }

                  indi = indj - 1;

                  nbrAgentsByBRG = this.getNbrAgentsByBRG(toObjectTmp, currentDate, currentShift, brgNameCurrent)
                  nbrAgentsByDispatchDateShift = this.getNbrAgentsByDispatchDateShift(toObjectTmp, currentDate, currentShift)

                  doc.autoTable({
                    head: this.headRowsBRG(brgNameCurrent.toUpperCase(), nbrAgentsByBRG),
                    headStyles: {
                      fillColor: [241, 196, 15],
                      fontSize: 15,
                      valign: 'middle'
                    },
                    footStyles: {
                      fillColor: [241, 196, 15],
                      fontSize: 12,
                      halign: 'right',
                      valign: 'middle'
                    },
                    lineWidth: 1,
                    tableLineColor: [241, 196, 15], //choose RGB
                    tableLineWidth: 0.02, //table border width
                    margin: {left: 0.75, top: 1.90, right: 0.75},
                    pageBreak: 'always', //'avoid'|'always'

                    didParseCell: function (data) {
                      if ((data.row.section === 'head') && (data.cell.text[0] === "(" + nbrAgentsByBRG + ")")) {
                        data.cell.styles.halign = 'right'
                        data.cell.styles.minCellWidth = 0.9
                      }

                      if ((data.row.section === 'head') && (data.cell.text[0] === brgNameCurrent.toUpperCase())) {
                        data.cell.styles.halign = 'right'
                      }
                    },

                    didDrawPage: function (data) {
                      // Header
                      //https://rawgit.com/MrRio/jsPDF/master/fontconverter/fontconverter.html pour convertir le font ttf en js.
                      doc
                          .addImage(response, 'PNG', 0.75, 0.75, 1.1, 1)
                          .addFileToVFS('MotionPicture-normal.ttf', MotionPicture)
                          .setFont("MotionPicture", 'normal')
                          .setFontSize(50)
                          .setTextColor(25, 52, 101)
                          .text("Dispatching", 3.20, 1.20);

                      doc
                          .setFont("times", "bolditalic")
                          .setFontSize(15)
                          .setTextColor(19, 39, 76)
                          .text(
                              nameDispatchShift + " (" + nbrAgentsByDispatchDateShift + ")",
                              7.75,
                              1.70,
                              {align: "right"}
                          )

                      // create a line under heading
                      doc.setDrawColor(19, 39, 76);
                      doc.setLineWidth(0.03).line(0.75, 1.80, 7.75, 1.80);
                      // Using autoTable plugin
                    },
                  });

                  nbrAgentsByZone = this.getNbrAgentsByZone(toObjectTmp, currentDate, currentShift, brgNameCurrent, zoneNameCurrent)
                  doc.autoTable({
                    startY: doc.lastAutoTable.finalY + 0.05,
                    head: this.headRowsZone(zoneNameCurrent.toUpperCase(), nbrAgentsByZone),
                    headStyles: {
                      fillColor: [74, 96, 117],
                      fontSize: 12,
                      halign: 'center',
                      valign: 'middle'
                    },
                    lineWidth: 1,
                    tableLineColor: [74, 96, 117], //choose RGB
                    tableLineWidth: 0.02, //table border width
                    margin: {left: 0.85, right: 0.85},

                    didParseCell: function (data) {
                      if ((data.row.section === 'head') && (data.cell.text[0] === "(" + nbrAgentsByZone + ")")) {
                        data.cell.styles.halign = 'right'
                        data.cell.styles.minCellWidth = 0.6
                      }

                      if ((data.row.section === 'head') && (data.cell.text[0] === zoneNameCurrent.toUpperCase())) {
                        data.cell.styles.halign = 'right'
                      }
                    },
                  });

                  let tabTPostMat = []
                  let posteNameCurrent = ""
                  let posteNameNext = ""
                  let incrSaut
                  let b1stSaut = 1;
                  let bFin = false;

                  for (var indk = 0; indk < finalTab.length; indk++) {
                    posteNameCurrent = finalTab[indk][5]

                    if (indk === (finalTab.length - 1)) {
                      bFin = true
                      posteNameNext = finalTab[indk][5]
                    } else {
                      posteNameNext = finalTab[indk + 1][5]
                    }

                    if ((posteNameCurrent === posteNameNext) && (bFin === false)) {
                      tabTPostMat.push([finalTab[indk][1], finalTab[indk][2], finalTab[indk][3], finalTab[indk][4], finalTab[indk][5], finalTab[indk][6], finalTab[indk][7], finalTab[indk][8], finalTab[indk][9]]);
                    } else {
                      tabTPostMat.push([finalTab[indk][1], finalTab[indk][2], finalTab[indk][3], finalTab[indk][4], finalTab[indk][5], finalTab[indk][6], finalTab[indk][7], finalTab[indk][8], finalTab[indk][9]]);

                      if ((posteNameCurrent !== posteNameNext) || (bFin === true)) {
                        if (b1stSaut === 1) {
                          incrSaut = 0
                          b1stSaut = 0
                        } else {
                          incrSaut = 0.2
                        }

                        doc.autoTable({
                          startY: doc.lastAutoTable.finalY + 0.03 + incrSaut,
                          head: this.headRowsPoste(posteNameCurrent, zoneNameCurrent),
                          headStyles: {
                            fillColor: [155, 89, 182],
                            fontSize: 10
                          },
                          margin: {left: 0.85, right: 0.85},

                          didParseCell: function (data) {
                            if ((data.row.section === 'head') && (data.cell.text[0] === zoneNameCurrent)) {
                              data.cell.styles.halign = 'right'
                            }
                          },
                        });

                        doc.autoTable({
                          startY: doc.lastAutoTable.finalY + 0.03,
                          head: this.bodyHead(),
                          body: this.bodyRows(tabTPostMat),
                          headStyles: {
                            fontSize: 10,
                          },
                          bodyStyles: {
                            fontSize: 10
                          },
                          margin: {left: 0.85, right: 0.85},
                          columnStyles: {
                            0: {cellWidth: 1},
                            1: {cellWidth: 2.9},
                            2: {cellWidth: 2}
                          },
                        });

                        tabTPostMat = []
                      }
                    }
                  }

                  if (indi !== (toObjectTmp.length - 1)) {
                    nextDate = toObjectTmp[indi + 1][1]
                    nextShift = toObjectTmp[indi + 1][2]
                  } else {
                    nextDate = ""
                    nextShift = ""
                  }

                  if (((nextDate === "") || (nextShift === "")) || ((currentDate !== nextDate) || (currentShift !== nextShift))) {
                    let result = this.getMessagesByDateShift(currentDate + " " + currentShift)

                    let elt = "Messages pour le dispatching du " + currentDate + " " + currentShift + ""
                    doc
                        .setFont("helvetica", "bold")
                        .setFontSize(16)
                        .text(elt, 1.09, doc.lastAutoTable.finalY + 1);

                    doc.autoTable({
                      startY: doc.lastAutoTable.finalY + 1.3,
                      head: this.headRowsMessages(),
                      body: this.bodyMessages(result),
                      headStyles: {
                        fontSize: 12,
                        fillColor: [185, 151, 91]
                      },
                      bodyStyles: {
                        fontSize: 10,
                        fillColor: [239, 219, 178]
                      },
                      margin: {left: 0.85, right: 0.85},
                    })

                    // PAGE NUMBERING
                    // Add Page number at bottom-right
                    // Get the number of pages
                    const pageCount = doc.internal.getNumberOfPages();

                    // For each page, print the page number and the total pages
                    for (var i = 1; i <= pageCount; i++) {
                      // Go to page i
                      doc.setPage(i);
                      //Print Page 1 of 4 for example  // Creating footer and saving file
                      this.footPage(doc)
                      doc
                          .setTextColor(25, 52, 101)
                          .text("Page " + String(i - 1) + " sur " + String(pageCount - 1), 7.7, doc.internal.pageSize.height - 0.5, {align: "right"});
                    }

                    doc.deletePage(1)
                    doc.save(`${this.heading} du ${currentDate}.${currentShift}.pdf`);

                    doc = new jsPDF({
                      orientation: "portrait",
                      unit: "in",
                      format: "letter"
                    });
                  }
                }
              }
          )
          .catch(
              (error) => {
                console.log(error); // Logs an error if there was one
              }
          )
    },
    bodyMessages(result) {
      var body = []
      for (var j = 0; j < result.length; j++) {
        body.push({
          name: result[j],
        })
      }
      return body
    },
    headRowsMessages() {
      return [
        {name: "Messages"},
      ]
    },
    headRowsBRG(brgName, size) {
      return [
        {name: brgName, size: "(" + size + ")"},
      ]
    },
    headRowsBRGR(doc, response, strDateReports) {
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth()

      doc
          .addImage(response, 'PNG', 20, 8, 17, 17)
          .addFileToVFS('MotionPicture-normal.ttf', MotionPicture)
          .setFont("MotionPicture", 'normal')
          .setFontSize(50)
          .setTextColor(25, 52, 101)
          .text("Global Reporting", pageWidth / 2, 21, {align: 'center'});

      doc
          .setFont("times", "bolditalic")
          .setFontSize(15)
          .setTextColor(19, 39, 76)
          .text(
              strDateReports,
              195,
              25,
              {align: "right"}
          )

      // create a line under heading
      doc.setDrawColor(19, 39, 76);
      doc.setLineWidth(1).line(20, 26, 195.9, 26);
    },
    headRowsZone(zoneName, size) {
      return [
        {name: zoneName, size: "(" + size + ")"},
      ]
    },
    headRowsPoste(poste, zone) {
      return [
        {name: 'POSTE :            ' + poste, zone: zone},
      ]
    },
    bodyHead() {
      return [
        {matricule: 'Matricule', name: 'Nom agent', categorie: 'Catégorie', date: 'Date'},
      ]
    },
    bodyRows(tabObject) {
      var body = []

      for (var j = 0; j < tabObject.length; j++) {
        body.push({
          matricule: tabObject[j][6],
          name: tabObject[j][7].toUpperCase() + " " + tabObject[j][8],
          categorie: tabObject[j][5],
          date: tabObject[j][0],
        })
      }
      return body
    },
    bodyRowsR(doc) {
      doc.setDrawColor(0);
      doc.setFillColor(241, 196, 15);
      doc.rect(20, 28, 175.9, 10, "F");

      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth()
      var lastY = 45
      for (var indk = 0; indk < this.reportsMessage.length; indk++) {
        let mesg = this.reportsMessage[indk]

        if (mesg.includes("SITUATION DE PRISE")) {
          doc.setFont("helvetica", "bold");
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(15);
          doc.text(mesg, pageWidth / 2, 35, {align: 'center'});
          continue;
        }
        if (mesg.includes("TSA PRIMAIRE") || mesg.includes("PRESTATION COMPAGNIE")) {
          let mesg2 = this.reportsMessage[indk + 1]
          let mesg3 = this.reportsMessage[indk + 2]

          var text = mesg + " / " + mesg2;

          doc.setFont("helvetica", "bold");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(12);
          doc.text(text, pageWidth / 2, lastY, {align: 'center'});

          if (lastY >= 250) {
            doc.addPage("letter", "p")
            lastY = 20
          } else {
            lastY = lastY + 5
          }

          text = "(" + mesg3 + ")";
          doc.text(text, pageWidth / 2, lastY, {align: 'center'});
          lastY = lastY + 8

          indk = indk + 2;
          continue;
        }
        if (mesg.includes(" - ")) {
          let mesg2 = this.reportsMessage[indk + 1]

          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(10);
          doc.text(mesg, 60, lastY);
          if ((lastY >= 250) || ((indk < this.reportsMessage.length - 1) && ((mesg2.includes("TSA PRIMAIRE") || mesg2.includes("PRESTATION COMPAGNIE"))))) {
            doc.addPage("letter", "p")
            lastY = 20
          } else {
            if ((indk < this.reportsMessage.length - 1) && (mesg2.includes("Personnel Encadrant") || mesg2.includes("TSA PRIMAIRE") || mesg2.includes("PRESTATION COMPAGNIE"))) {
              lastY = lastY + 10
            } else if ((indk < this.reportsMessage.length - 1) && !mesg2.includes("-")) {
              lastY = lastY + 7
            } else {
              lastY = lastY + 5
            }
          }
          continue;
        }

        if (mesg.includes("Zone") || mesg.includes(" * ")) {
          let mesg2 = this.reportsMessage[indk + 1]

          doc.setFont("helvetica", "bolditalic");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(10);
          doc.text(mesg, 55, lastY);
          if ((lastY >= 250) || ((indk < this.reportsMessage.length - 1) && ((mesg2.includes("TSA PRIMAIRE") || mesg2.includes("PRESTATION COMPAGNIE"))))) {
            doc.addPage("letter", "p")
            lastY = 20
          } else {
            lastY = lastY + 5
          }
        } else {
          let mesg2 = this.reportsMessage[indk + 1]

          if (mesg.includes("Nombre") || mesg.includes("Liste Absences") || mesg.includes("Personnel Encadrant") || mesg.includes("théorique")) {
            doc.setFont("helvetica", "bold");
          } else {
            doc.setFont("helvetica", "normal");
          }

          doc.setTextColor(0, 0, 0);
          doc.setFontSize(10);
          doc.text(mesg, 50, lastY);
          if ((lastY >= 250) || ((indk < this.reportsMessage.length - 1) && ((mesg2.includes("TSA PRIMAIRE") || mesg2.includes("PRESTATION COMPAGNIE"))))) {
            doc.addPage("letter", "p")
            lastY = 20
          } else {
            if ((indk < this.reportsMessage.length - 1) && (mesg2.includes("Personnel Encadrant") || mesg2.includes("TSA PRIMAIRE") || mesg2.includes("PRESTATION COMPAGNIE"))) {
              lastY = lastY + 10
            } else {
              lastY = lastY + 5
            }
          }
        }
      }

      if ((this.listPresencesNotPlanned.length !== 0)) {
        doc.addPage("letter", "p")
        lastY = 20

        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);

        let mesg = "Nombre ADS présents mais non plannifiés : " + this.listPresencesNotPlanned.length
        doc.text(mesg, 50, lastY);

        mesg = "Liste ADS présents mais non plannifiés : "
        lastY = lastY + 5
        doc.text(mesg, 50, lastY);

        doc.setFont("helvetica", "normal");
        for (var i = 0; i < this.listPresencesNotPlanned.length; i++) {
          mesg = this.listPresencesNotPlanned[i];
          lastY = lastY + 5
          doc.text(mesg, 60, lastY);

          if (lastY >= 250) {
            doc.addPage("letter", "p")
            lastY = 20
          }
        }
      }
    },
    footPageR(doc) {
      // Creating footer and saving file
      doc
          .setFont("times", "italic")
          .setFontSize(11)
          .setTextColor(25, 52, 101)
          .text(
              "Powered with love by CartaLink - (TSA / Aéroport AIBD) - Document confidentiel.",
              20,
              doc.internal.pageSize.height - 15
          )
    },
    footPage(doc) {
      // Creating footer and saving file
      doc
          .setFont("times", "italic")
          .setFontSize(11)
          .setTextColor(25, 52, 101)
          .text(
              "Powered with love by CartaLink - (TSA / Aéroport AIBD) - Document confidentiel.",
              0.75,
              doc.internal.pageSize.height - 0.5
          )
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData()
    },
    cleared() {
      this.searchName = "";
      this.getData()
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateIssuer(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      this.loading = true
      let valeur = this.depthVal.value
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/dispatchingresults/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                this.convertDate(item["dispatchingDate"]),
                this.isEmpty(item["shiftName"]) ? "" : item["shiftName"].toUpperCase(),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                (item["zoneName"].toUpperCase() === "TOUTES ZONES") ? "ZONE X" : item["zoneName"].toUpperCase(),
                this.isEmpty(item["postName"]) ? "" : item["postName"].toUpperCase(),
                this.isEmpty(item["category"]) ? "" : ((item["aao"] === true) ? (item["category"].toUpperCase() + " - AAO") : item["category"].toUpperCase()),
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["status"]) ? "" : item["status"],
                this.datefull(item["creationDate"])
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]

            this.getNotifsByDateDepth(valeur)
          })
          .catch(() => {
            this.loading = false
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    loadShifts() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Shifts", null)
            let datas = response.data.datas;
            this.shiftsFull = datas;
            this.shifts = []
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
            });
            sessionStorage.setItem("Shifts", JSON.stringify(this.shifts))
          })
          .catch(() => {
          });
    },
    presencesNotPlanned() {
      apiClient
          .get(`${this.$store.getters.user.baseUrl}/reports/presencesnotpredictedreportbydate/` + moment(this.dateReports).format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId"))
          .then(response => {
            this.listPresencesNotPlanned = response.data.datas;
            this.generateRapportPDF()
          })

          .catch(() => {
            this.loading = false
          });
    },
    show() {
      this.$modal.show('modal-fade-observations');
    },
    hide() {
      this.depthDate()
      this.$modal.hide('modal-fade-observations');
    },
    Annuler() {
      this.hide()
      this.observations = ""
      this.getData()
    },
    showPDF() {
      this.$modal.show('modal-fade');
    },
    showR() {
      this.$modal.show('modal-fade-reports');
    },
    hideR() {
      this.$modal.hide('modal-fade-reports');
      this.dateReports = null;
    },
    AnnulerR() {
      this.hideR()
    },
    sendNotif() {
      let idFctIssuer = this.formatDateIssuer(this.editedItem.dispatchingDate) + " " + this.editedItem.shiftName
      const dataToSave = {
        message: "Dispatch du " + this.formatDateIssuer(this.editedItem.dispatchingDate) + " (" + this.editedItem.shiftName + ")\n" +
            "Raison affectation du matricule " + this.editedItem.userId + "\n -> " + this.observations,
        userId: "Admin",
        idFctIssuer: idFctIssuer,
        broadcastListName: "Dispatch_staff",
        revisedUser: sessionStorage.getItem("userId")
      };
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/notification/add/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(response => {
            this.observations = ""
          })
          .catch(() => {
            this.observations = ""
          });
    },
    Valider() {
      this.loading = true

      let contrainte = null
      this.nameCtgContraintesAgt.forEach(item2 => {
        let str1 = item2[0].toUpperCase()

        if (str1.localeCompare(this.editedItem.categAgent) === 0) {
          contrainte = item2[1];
        }
      })

      if (contrainte === null) {
        this.text = "La catégorie de l'agent " + this.editedItem.categAgent + " n'est pas reconnu par le logiciel."
        this.showAlert('warning')
        this.loading = false
        this.refresh()
        this.hide()
        return;
      }

      const dataToSave = {
        id: this.editedItem.id,
        dispatchingDate: this.editedItem.dispatchingDate,
        shiftName: this.editedItem.shiftName,
        postName: this.editedItem.postName,
        userId: this.editedItem.userId,
        contrainte: contrainte,
        revisedUser: sessionStorage.getItem("userId")
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/dispatchingaffectation/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.hide()
            this.loading = false

            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message;

              this.showAlert('info')
              this.getData()

              this.sendNotif()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;

              this.showAlert('warning')
              this.getData()
            }
          })
          .catch((err) => {
            this.alert = true
            this.color = "#F44336"
            this.text = err.data.message;
            this.loading = false
            this.hide()

            this.showAlert('warning')
            this.depthDate();
          });
    },
    ValiderR() {
      this.$modal.hide('modal-fade-reports');
      this.loading = true

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/dispatchingglobalreports/` + moment(this.dateReports).format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId")
          )
          .then(res => {
            this.loading = false
            this.dialog = false;

            if (res.data.status === 200) {
              this.color = "#009688"
              this.reportsMessage = res.data.datas;
              this.presencesNotPlanned()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;

              this.showAlert('warning')
              this.getData()
            }
          })
          .catch((err) => {
            this.alert = true
            this.color = "#F44336"
            this.text = err.data.message;
            this.loading = false

            this.showAlert('warning')
            this.depthDate();
          });
    },
    loadPostes() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/enableposts4rules/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Postes4rules", null)

            let datas = response.data.datas;
            this.namePostsZones = [];
            this.namePosts = [];
            this.nameZones = [];
            datas.forEach(item => {
              this.namePosts.push(item.name.toUpperCase(true));
              this.nameZones.push(item.zone.toUpperCase(true));
              this.namePostsZones.push([item.name.toUpperCase(true), item.zone.toUpperCase(true)]);
            });

            this.namePosts.sort()
            sessionStorage.setItem("Postes4rules", JSON.stringify(this.namePosts))

            this.namePostsZones.forEach(item2 => {
              let str1 = item2[0].toUpperCase()
              let str2 = this.editedItem.postName1.toUpperCase()

              if (str1.localeCompare(str2) === 0) {
                this.editedItem.zoneName1 = item2[1];
              }
            })
          })
          .catch(() => {
          });
    },
    loadCategoriesAgent() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/categoriesagent/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("CategoriesAgent", null)

            let datas = response.data.datas;
            this.nameCtgContraintesAgt = [];
            this.nameCategAgent = [];
            this.nameContrainteAgent = [];
            datas.forEach(item => {
              this.nameCategAgent.push(item.category.toUpperCase(true));
              this.nameContrainteAgent.push(item.contrainte);
              this.nameCtgContraintesAgt.push([item.category.toUpperCase(true), item.contrainte]);
            });

            this.nameCategAgent.sort()
            sessionStorage.setItem("CategoriesAgent", JSON.stringify(this.nameCategAgent))

            this.nameCtgContraintesAgt.forEach(item2 => {
              let str1 = item2[0].toUpperCase()
              let str2 = this.editedItem.categAgent.toUpperCase()

              if (str1.localeCompare(str2) === 0) {
                this.editedItem.contrainteAgent = item2[1];
              }
            })
          })
          .catch(() => {
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.initEditedItem();
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    getMessagesByDateShift(idFctIssuer) {
      let result = []
      let stTmp = []
      this.tabDispatchAllMessages.forEach(item => {
        stTmp = item.message.split('\n')

        if (item.idFctIssuer === idFctIssuer) {
          if (stTmp.length >= 2) {
            result.push(stTmp[1] + ((stTmp.length === 3) ? (" : " + stTmp[2]) : ""));
          }
        }
      })

      return result
    },
    getNotifsByDateDepth(valeur) {
      let dateChoosed = moment().subtract(valeur, "days").format("DD-MM-YYYY")
      this.tabDispatchAllMessages = []

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/notification/getnotifsbydatebydepth/` + dateChoosed + "/Admin"
          )
          .then(res => {
            if (res.data.status === 200) {
              for (let i = 0; i < res.data.datas.length; i++) {
                this.tabDispatchAllMessages.push(res.data.datas[i]);
              }
            }
          })
          .catch(() => {
          });
    },
    afterOnCellMouseUpMe: function (event, coords) {
      if (coords.col === 1 && coords.row >= 0) // Column 18 of my table
      {
        let dtDispatching = this.$refs.hotTable.hotInstance.getDataAtCell(coords.row, 1); // row number and column number
        let shift = this.$refs.hotTable.hotInstance.getDataAtCell(coords.row, 2); // row number and column number
        //console.log($id); // testing the results

        this.idFctIssuer = dtDispatching + " " + shift

        const vm = this;
        vm.loading = true
        vm.file = ""

        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/notification/getnotifsbyissuer/` + this.idFctIssuer + "/Admin" // On ne remonte que les notifs liées au dispatch
            )
            .then(res => {
              let dataError = []
              vm.loading = false
              if (res.data.status === 200) {
                for (let i = 0; i < res.data.datas.length; i++) {
                  dataError.push(res.data.datas[i]);
                }

                vm.alert = true
                vm.color = "#009688"
                vm.errors = dataError
                vm.file = "";
              } else {
                vm.text = "Il n y a pas de messages pour le dispatching du " + this.idFctIssuer + "."
                vm.showAlert('warning')
              }
            })
            .catch(() => {
              vm.loading = false
            });
      }
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du dispatching de l\'agent.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.initEditedItem();
              let obj = {}
              let contrainte = -1

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              let sdate = moment(obj[1], "DD-MM-YYYY").format("YYYY-MM-DD")

              if (obj[5] === "") {
                this.text = "Le nom du poste doit être rempli."
                this.showAlert('warning')
                this.loading = false
                this.refresh()
                dialog.close();
                return;
              }

              if (changes[0][1] === 5) {
                this.namePostsZones.forEach(item2 => {
                  let str1 = item2[0].toUpperCase()
                  let str2 = obj[5].toUpperCase()

                  if (str1.localeCompare(str2) === 0) {
                    obj[4] = item2[1];
                  }
                })

                this.nameCtgContraintesAgt.forEach(item2 => {
                  let str1 = item2[0].toUpperCase()
                  let str2 = obj[6].toUpperCase()

                  if (str1.localeCompare(str2) === 0) {
                    contrainte = item2[1];
                  }
                })
              } else if (changes[0][1] === 6) {
                this.nameCtgContraintesAgt.forEach(item2 => {
                  let str1 = item2[0].toUpperCase()
                  let str2 = obj[6].toUpperCase()

                  if (str1.localeCompare(str2) === 0) {
                    contrainte = item2[1];
                  }
                })
              }

              this.editedItem.id = obj[0]
              this.editedItem.dispatchingDate = sdate
              this.editedItem.shiftName = obj[2]
              this.editedItem.zoneName = obj[4]
              this.editedItem.postName = obj[5]
              this.editedItem.contrainte = (contrainte === -1) ? 14 : contrainte
              this.editedItem.categAgent = obj[6]
              this.editedItem.userId = obj[7]

              dialog.close();
              this.show()
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du dispatching de l\'agent.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/dispatchingresultagent/` + rowId[0] + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);
          });
    },
    initEditedItem() {
      this.editedItem.postName =
          this.editedItem.zoneName =
              this.editedItem.zoneName1 =
                  this.editedItem.categAgent =
                      this.editedItem.contrainteAgent =
                          this.editedItem.postName1 =
                              this.editedItem.brigade =
                                  this.editedItem.userId1 =
                                      this.editedItem.userId =
                                          this.editedItem.accountFirstname =
                                              this.editedItem.accountLastname =
                                                  this.editedItem.sexe =
                                                      this.editedItem.shiftName =
                                                          this.editedItem.shiftNameS =
                                                              this.observations =
                                                                  this.editedItem.shiftName1 = "";

      this.editedItem.dispatchingDate = (moment().format("YYYY-MM-DD")).toString();
      this.editedItem.dispatchingDate1 = (moment().format("YYYY-MM-DD")).toString();
      this.editedItem.dispatchingDateS = (moment().format("YYYY-MM-DD")).toString();
    },
    creer() {
      this.loading = true
      this.dialog = false

      const dataToSave = {
        shiftName: this.editedItem.shiftName,
        dispatchingDate: moment(this.editedItem.dispatchingDate).format("YYYY-MM-DD")
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/dispatchingresult/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message;
              this.dialog = false;
              this.getData()
              this.showAlert('info')
              this.initEditedItem()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning')
            }
          })
          .catch(err => {
            this.alert = true
            this.text = err;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    supprimer() {
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du dispatching.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true
            this.dialog = false

            let idFctIssuer = this.formatDateIssuer(this.editedItem.dispatchingDateS) + " " + this.editedItem.shiftNameS

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/dispatchingresult/` + this.editedItem.shiftNameS + "/" + moment(this.editedItem.dispatchingDateS).format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.dialog = false;
                    this.getData()
                    this.showAlert('info')
                    this.initEditedItem()

                    apiClient.delete(
                            `${this.$store.getters.user.baseUrl}/notification/deletenotifsbyissuer/` + idFctIssuer + "/" + sessionStorage.getItem("userId")
                        )
                        .then(response => {
                        })
                        .catch(() => {
                        });
                  } else {
                    this.alert = true
                    this.color = "#F44336"
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch(err => {
                  dialog.close();
                  this.alert = true
                  this.text = err;
                  this.dialog = false;
                  this.loading = false
                  this.color = "#F44336"
                  this.showAlert('warning')
                });
          })
          .catch(() => {

          });
    },
    affectation() {
      this.loading = true
      this.dialog = false

      const dataToSave = {
        shiftName: this.editedItem.shiftName1,
        dispatchingDate: this.editedItem.dispatchingDate1,
        postName: this.editedItem.postName1,
        userId: this.editedItem.userId1,
        contrainte: this.editedItem.contrainte // Affectation
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/dispatchingaffectation/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message;
              this.dialog = false;
              this.getData()
              this.showAlert('info')
              this.sendNotif()
              this.initEditedItem()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning')
            }
          })
          .catch(err => {
            this.alert = true
            this.text = err;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    RemoveAccents(sAccents) {
      var strAccents = sAccents.split('');
      var strAccentsOut = [];
      var strAccentsLen = strAccents.length;
      var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
      var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) !== -1) {
          strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else {
          strAccentsOut[y] = strAccents[y];
        }
      }
      strAccentsOut = strAccentsOut.join('');
      return strAccentsOut;
    },
    isInt(value) {
      var x = parseFloat(value);
      return !isNaN(value) && (x | 0) === x;
    },
    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true

      if (this.toObject.length <= 1) {
        this.text = "Il n'y a aucun enregistrement à télécharger.";
        this.showAlert('warning')
        return;
      }

      let dispatchDateTab = []
      this.toObject.forEach(item => {
        dispatchDateTab.push(item[1] + "_" + item[2]);
      })

      dispatchDateTab.shift()
      let dispatchDateTabUnique = new Set(dispatchDateTab)

      let finalTab = []

      this.toObject.forEach(item => {
        finalTab.push([item[1], item[2], item[3], item[4], item[5], item[6], item[7], item[8], item[9]]);
      });

      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      dispatchDateTabUnique.forEach(item => {
        let finalTabSpecif = []

        finalTab.forEach(item2 => {
          if ((item2[0] + "_" + item2[1]) === item) {
            finalTabSpecif.push([item2[2], item2[3], item2[4], item2[5], item2[6], item2[7], item2[8]]);
          }
        });

        finalTabSpecif.unshift([this.toObject[0][3], this.toObject[0][4], this.toObject[0][5], this.toObject[0][6], this.toObject[0][7], this.toObject[0][8], this.toObject[0][9]]);
        var datas = XLSX.utils.json_to_sheet(finalTabSpecif, {skipHeader: true})
        XLSX.utils.book_append_sheet(wb, datas, item) // sheetAName is name of Worksheet
      });

      // export Excel file
      XLSX.writeFile(wb, "Résultat_dispatching.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.colTSABRG1 {
  text-align: center;
  color: #f0f0f0;
  background-color: #9c8f69 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colTSABRG2 {
  text-align: center;
  color: #f0f0f0;
  background-color: #689c8f !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colTSABRG3 {
  text-align: center;
  color: #f0f0f0;
  background-color: #68759c !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colTSABRG4 {
  text-align: center;
  color: #f0f0f0;
  background-color: #9c6875 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colTSABRGX {
  text-align: center;
  color: #f0f0f0;
  background-color: #E57373 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colZ1 {
  text-align: center;
  background-color: #81D4FA !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.colZ1Name {
  text-align: center;
  background-color: #E1F5FE !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colZ2 {
  text-align: center;
  background-color: #CE93D8 !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.colZ2Name {
  text-align: center;
  background-color: #F3E5F5 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colZ3 {
  text-align: center;
  background-color: #A5D6A7 !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.colZ3Name {
  text-align: center;
  background-color: #E8F5E9 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colZ4 {
  text-align: center;
  background-color: #FFF59D !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.colZ4Name {
  text-align: center;
  background-color: #FFFDE7 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colZ5 {
  text-align: center;
  background-color: #B0BEC5 !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.colZ5Name {
  text-align: center;
  background-color: #ECEFF1 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colZ6 {
  text-align: center;
  background-color: #BCAAA4 !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.colZ6Name {
  text-align: center;
  background-color: #EFEBE9 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.colZX {
  text-align: center;
  background-color: #FFAB91 !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.colZXName {
  text-align: center;
  background-color: #FBE9E7 !important;
  font-weight: bold !important;
  font-style: normal !important;
}
</style>